import { Col, Container, Row } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import Swatch from 'components/Swatch';
import Price from 'components/Price';
import { ReactComponent as ArrowLeft } from 'assets/images/icons/ArrowLeft.svg';
import { ReactComponent as ArrowRight } from 'assets/images/icons/ArrowRight.svg';

const TyresSelector = ({ title, activeItem, onChange, price, placeholderImage }) => {

  return (
    <div className="c-threesixty__colors">
      <p className="c-threesixty__descr">
        <span className="c-threesixty__title">{title}</span>
        {!!activeItem && <strong className="c-threesixty__price"><Price price={price} /></strong>}
      </p>
      <Swiper
        className="swatch-swiper"
        cssMode={true}
        slidesPerView={'auto'}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        mousewheel={true}
        keyboard={true}
        modules={[Navigation, Mousewheel, Keyboard]}
      >
          <SwiperSlide>
            <div className="swiper-group">
              
                <Swatch
                  img={placeholderImage}
                  //name={radio.name}
                  value="winterTyres"
                  selectedValue={activeItem}
                  setSelected={onChange}
                  type="checkbox"
                />
              <span className="swiper-label">+ <Price price={price} /></span>
            </div>
          </SwiperSlide>

        <button className="swiper-button swiper-button-prev" type="button"><ArrowLeft /></button>
        <button className="swiper-button swiper-button-next" type="button"><ArrowRight /></button>
      </Swiper>
    </div>
  );
};

export default TyresSelector;